import { render, staticRenderFns } from "./AoForm.vue?vue&type=template&id=10bf3f74&"
import script from "./AoForm.vue?vue&type=script&lang=js&"
export * from "./AoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports